import { render, staticRenderFns } from "./PUIList.vue?vue&type=template&id=45052474&scoped=true&"
import script from "./PUIList.vue?vue&type=script&lang=js&"
export * from "./PUIList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45052474",
  null
  
)

export default component.exports